/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-multi-comp */
/* eslint-disable no-unused-vars */
import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Link } from 'react-router-dom';

import {
  Grid2,
  Button as ButtonMaterial,
  Typography,
  CircularProgress,
  Modal,
  Box,
  Stepper,
  Step,
  StepButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  IconButton,
  AppBar,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Button,
  Chip,
  InputAdornment,
} from '@mui/material';
import MuiDialogActions from '@mui/material/DialogActions';

import { makeStyles } from '@mui/styles';
import { ChargeCard, GroupCard, MimicoCard } from '../index';
import {
  showCharge,
  deleteCharge,
  updateChargeOwnerData,
  getChargeOwnerData,
  showTmpCharge,
  getChargeVoltage,
  postApportionment,
  getSolarCapacity,
} from 'js/actions/chargeActions';
import getToken, { isAllowed } from 'helpers/auth';
import Swal from 'sweetalert2';
import styles from './styles';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { Close, Delete } from '@mui/icons-material';
import { showCards } from 'js/actions/cardAction';
import { getGeneralConsume } from 'js/actions/chargeDashboardActions';
import { withStyles } from '@mui/styles';
import FromStrepper from './FromStrepper';
import {
  getSnapShot,
  postSnapShot,
  updateSnapShop,
} from 'js/actions/userActions';
import axios from 'axios';

const getConfig = () => {
  return {
    headers: { Authorization: 'Bearer ' + getToken() },
  };
};

const useStyles = makeStyles(styles);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    borderTop: '1px solid rgb(128 128 128 / 50%)',
  },
}))(MuiDialogActions);

export default function ChargeGrid(props) {
  const classes = useStyles();
  const intl = useIntl();
  const { groupId, className, charge, typeEnergy, mimicoView } = props;
  const dispatch = useDispatch();
  const rootClassName = classNames(classes.root, className);
  let charges = useSelector((state) => state.charges.charges);
  const user = useSelector((state) => state.user.user);
  const chargeOwner = useSelector((state) => state.charges.chargeOwner);
  const owner = useSelector(
    (state) => state.chargeDashboard.generalConsumes.charge_info
  );
  const [activeStep, setActiveStep] = React.useState(0);
  const groups = useSelector((state) => state.groups.groups);
  const [tabIndex, setTabIndex] = React.useState(0);
  const storedGroupName = localStorage.getItem(`groupName_${groupId}`);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const chargeInfo = useSelector((state) => state.charges.charge);
  const [tmpCharge, setTmpCharge] = useState({});
  const corporative = useSelector((state) => state.user.corporative);
  const [chargeVolts, setChargeVolts] = React.useState([]);
  const [newOwnerName, setNewOwnerName] = useState('');
  const [ownerName, setOwnerName] = useState(
    chargeOwner && chargeOwner !== null ? chargeOwner : ''
  );
  const [openReceiptDialog, setOpenReceiptDialog] = useState(false);
  const [snapShopView, setSnapShopView] = useState(false);
  const [solarCapacity, setSolarCapacity] = useState(false);
  const [solarInput, setSolarInput] = useState();
  const [formData, setFormData] = useState({
    resource_id: selectedCharge ? selectedCharge.id : null,
    type: 'CARGA',
    frecuency_config: {
      periods: [],
      days: [],
    },
    contacts: [],
  });
  let chargeState = useSelector((state) => state.charges.loading);
  let isLoading = chargeState;
  const { snapShot } = useSelector((state) => state.user);
  const [apportionments, setApportionments] = useState([]);
  const [listCharges, setListCharges] = useState([]);
  const [newApportionment, setNewApportionment] = useState({
    group: '',
    groupName: '',
    charge: '',
    chargeName: '',
  });
  const [openAppotioments, setOpenApportiments] = useState(false);

  useEffect(() => {
    if (selectedCharge) {
      dispatch(getSnapShot(selectedCharge.id, 'CARGA'));
    }
  }, [selectedCharge]);

  useEffect(() => {
    if (snapShot && snapShot.length > 0) {
      setFormData(snapShot[0]);
    }
  }, [snapShot]);

  useEffect(() => {
    if (selectedCharge) {
      setSolarInput(selectedCharge.solar_capacity);
    }
  }, [selectedCharge]);

  useEffect(() => {
    if (selectedCharge)
      dispatch(
        getGeneralConsume(
          selectedCharge.id,
          new Date().getFullYear(),
          new Date().getMonth() + 1
        )
      );
  }, [selectedCharge]);

  const handleSnapShot = () => {
    if (snapShot && snapShot.length > 0) {
      dispatch(updateSnapShop(formData)).then(() => {
        setSnapShopView(false);
      });
    } else {
      dispatch(postSnapShot(formData)).then(() => {
        setSnapShopView(false);
      });
    }
  };

  const handleAppointment = () => {
    dispatch(postApportionment(selectedCharge.id, apportionments));
    setApportionments([]);
    setListCharges([]);
    setOpenApportiments(false);
  };

  const fetchTmpCharge = async (chargeId) => {
    try {
      const response = await axios.get(
        `https://api.metimur.mx/api/charge/${chargeId}`,
        getConfig()
      );
      return response.data.data; // Retornar la información de la carga
    } catch (error) {
      console.error('Error al obtener la carga:', error);
      return null; // Retornar null si hay un error
    }
  };

  // useEffect para inicializar los apportionments si `charges.apportionment === 1`
  useEffect(() => {
    const initializeApportionments = async () => {
      if (selectedCharge) {
        if (selectedCharge.apportionment === '1') {
          const newApportionments = [];
          for (const selected of selectedCharge.apportionment_ids) {
            const tmpCharge = await fetchTmpCharge(selected.id); // Obtener la información de la carga
            if (tmpCharge) {
              const groupName =
                groups.find((group) => group.id === tmpCharge.group_id).name ||
                '';
              newApportionments.push({
                group: tmpCharge.group_id,
                groupName: groupName,
                charge: tmpCharge.id,
                chargeName: tmpCharge.name,
              });
            }
          }
          setApportionments(newApportionments); // Actualizar el estado una vez que todas las cargas sean procesadas
        }
      }
    };

    initializeApportionments();
  }, [selectedCharge]);

  useEffect(() => {
    if (corporative) {
      dispatch(getChargeVoltage(corporative.id, funcVoltage));
    }
  }, [corporative]);

  const funcVoltage = (info) => {
    info ? setChargeVolts(info) : setChargeVolts([]);
  };

  useEffect(() => {
    if (selectedCharge) {
      dispatch(showTmpCharge(selectedCharge.id));
    }
  }, [selectedCharge]);

  useEffect(() => {
    setOwnerName(chargeOwner && chargeOwner !== null ? chargeOwner : '');
  }, [chargeOwner]);

  useEffect(() => {
    setTmpCharge({ ...tmpCharge, charge });
  }, [charge]);

  useEffect(() => {
    if (groups[0]) {
      localStorage.setItem(`groupName_${groupId}`, groups[0].name);
    }
  }, [groups, groupId]);

  const groupName = groups[0] ? groups[0].name : storedGroupName;

  const getSteps = () => {
    return [
      intl.formatMessage({
        id: 'app.chargesCards.addCharge.stepper.measurement.title',
      }),
      intl.formatMessage({
        id: 'app.chargesCards.addCharge.stepper.setting.title',
      }) /* 'Rango de Medición' */,
    ];
  };
  const steps = getSteps();

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const comunicaciones = () => {
    const chargeType = () => {
      switch (selectedCharge.charge.charge_type) {
        case '1':
          return 'MONOFASICA';
        case '2':
          return 'BIFASICA';
        case '3':
          return 'TRIFASICA';
        default:
          return selectedCharge.charge.charge_type;
      }
    };

    return (
      <Box
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.comunications.Params',
          })}{' '}
          {selectedCharge.type_unit}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.comunications.tipElemLbl',
          })}
          : {selectedCharge.charge.element_type}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.comunications.measureTypeLbl',
          })}
          : {chargeType()}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.comunications.inputsUsed',
          })}
          : {selectedCharge.charge.num_inputs}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.comunications.groupLbl',
          })}
          : {groupName}
        </Typography>
      </Box>
    );
  };

  const medicion = () => {
    const phases = () => {
      return chargeInfo?.inputs?.map((item) => (
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          fontWeight={400}
          key={item.id}
        >
          <Typography variant="h5" style={{ fontWeight: 400 }}>
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.modBusLbl',
            })}
            : {item.card_modbus}
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 400 }}>
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.inputsLbl',
            })}
            : {item.input}
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 400 }}>
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.relationLbl',
            })}
            : {item.relation}
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 400 }}>
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.adjustLbl',
            })}
            : {item.ajust}
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 400 }}>
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.offsetLbl',
            })}
            : {item.offset}
          </Typography>
        </Box>
      ));
    };
    return (
      <Box style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box style={{ marginBottom: '10px' }}>
          <Typography
            variant="h4"
            style={{ marginBottom: '10px', textAlign: 'center' }}
          >
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.phaseConftitle',
            })}
          </Typography>
          {phases()}
        </Box>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 400 }}
        >
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            {intl.formatMessage({
              id: 'app.chargesCards.editCharge.stepper.configuration.predefVolt',
            })}
          </Typography>
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.configuration.voltageLbl',
          })}
          : {chargeInfo.voltage ? chargeInfo.voltage.constant_value : null}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 400 }}
        >
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            {intl.formatMessage({
              id: 'app.chargesCards.addCharge.stepper.configuration.nivelLbl',
            })}
          </Typography>
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.configuration.nivelLbl',
          })}
          : {chargeInfo && chargeInfo.is_father === 1 ? 'Master' : 'Slave'}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.configuration.dynamicFP',
          })}
          : {chargeInfo.voltage && chargeInfo.voltage.is_constant ? 'No' : 'Si'}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 400 }}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.configuration.dynamicVoltage',
          })}
          : {chargeInfo.fp && chargeInfo.fp.is_constant ? 'No' : 'Si'}
        </Typography>
        <Typography
          variant="h5"
          style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 400 }}
        >
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            {intl.formatMessage({
              id: 'app.chargesCards.addCharge.stepper.configuration.fpLbl',
            })}
          </Typography>
          {intl.formatMessage({
            id: 'app.chargesCards.editCharge.stepper.configuration.prede',
          })}
          : {chargeInfo.fp ? chargeInfo.fp.constant_value : null}
        </Typography>
      </Box>
    );
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return comunicaciones();
      case 1:
        return medicion();
      // case 2:
      //   return rangoMedicion();
      default:
        return null;
    }
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  //const corporativeId = corpUser === undefined || corpUser === null ? corpAdmin.id : corpUser.id

  useEffect(() => {
    dispatch(showCharge(groupId));
  }, []);

  useEffect(() => {
    props.handleCountStatusChanged();
  }, [props.handleCountStatusChanged]);

  const deleteChargeData = (charge) => {
    Swal.fire({
      title: `${intl.formatMessage({ id: 'app.chargesCards.deleteChargeBtn.title' })} `,
      text: `${intl.formatMessage({ id: 'app.chargesCards.deleteChargeBtn.text' })} ${charge.name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: 'app.chargesCards.deleteChargeBtn.confirmation',
      }),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: intl.formatMessage({
            id: 'app.chargesCards.deleteChargeBtn.titleConfirmation',
          }),
          text: intl.formatMessage({
            id: 'app.chargesCards.deleteChargeBtn.textConfirmation',
          }),
          icon: 'success',
        });
        dispatch(deleteCharge(charge.id));
      }
    });
  };

  const handleOpenReceiptDialog = (charge) => {
    dispatch(getChargeOwnerData(charge ? charge.id : null));
    setSelectedCharge(charge);
    setOpenReceiptDialog(true);
  };

  const handleCloseReceiptDialog = () => {
    setOpenReceiptDialog(false);
  };

  const handleSolarCapacity = () => {
    const capacity = parseInt(solarInput);
    if (typeof capacity !== 'number') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'El Campo debe ser un Numero Entero',
      });
    } else {
      dispatch(getSolarCapacity(selectedCharge.id, capacity));
      setSolarCapacity(false);
      setSolarInput('');
    }
  };

  const handleSaveReceiptData = () => {
    dispatch(updateChargeOwnerData(selectedCharge.id, newOwnerName))
      .then(() => {
        setOpenReceiptDialog(false);
        setNewOwnerName('');
      })
      .then(
        Swal.fire({
          icon: 'success',
          title: 'Carga actualizada correctamente',
        })
      )
      .catch(function (error) {
        const errorMessage = error.response.data.message;

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `<br/>${errorMessage.join('<br/>')}`,
        });
      });
  };

  const [showEditButton, setShowEditButton] = useState(false);
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [showInvoiceDataButton, setShowInvoiceDataButton] = useState(false);
  const [showReceiptDataButton, setShowReceiptDataButton] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const getReceiptData = (charge) => {
    if (showReceiptDataButton === false) {
      return <div />;
    } else {
      return (
        <ButtonMaterial
          color="secondary"
          onClick={() => handleOpenReceiptDialog(charge)}
          variant="outlined"
        >
          {intl.formatMessage({ id: 'app.chargesCards.receiptData.tooltip' })}
        </ButtonMaterial>
      );
    }
  };

  const getEditButton = (charge) => {
    if (showEditButton == false) {
      return <div />;
    } else {
      return (
        <Link
          to={{
            pathname: `/updateCharge/${charge.id}`,
            state: { charge: charge },
          }}
        >
          <ButtonMaterial color="secondary" variant="outlined">
            {intl.formatMessage({ id: 'app.chargesCards.editChargeBtn' })}
          </ButtonMaterial>
        </Link>
      );
    }
  };

  const getDeleteButton = (charge) => {
    if (showDeleteButton == false) {
      return <div />;
    } else {
      return (
        <ButtonMaterial
          onClick={() => deleteChargeData(charge)}
          sx={{ border: '1px solid #D64539', color: '#D64539' }}
          variant="outlined"
        >
          {intl.formatMessage({ id: 'app.chargesCards.deleteChargeBtn' })}
        </ButtonMaterial>
      );
    }
  };

  const getInvoiceDataButton = (charge) => {
    if (showInvoiceDataButton == false) {
      return <div />;
    } else {
      return (
        <Link
          to={`/invoiceDataCharge/${charge.id}`}
          state={{ charge: charge, groupId: groupId }}
        >
          <ButtonMaterial color="secondary" variant="outlined">
            {intl.formatMessage({ id: 'app.chargesCards.invDataBtn' })}
          </ButtonMaterial>
        </Link>
      );
    }
  };

  const receiptDialog = (
    <Dialog
      open={openReceiptDialog}
      onClose={handleCloseReceiptDialog}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle>
        {intl.formatMessage({ id: 'app.chargesCards.receiptData.title' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {!ownerName
            ? `${intl.formatMessage({ id: 'app.chargesCards.receiptData.label' })} ${selectedCharge ? selectedCharge.name : ''}`
            : `${intl.formatMessage({ id: 'app.chargesCards.receiptData.labelName' })} ${ownerName}`}
        </DialogContentText>
        <TextField
          margin="dense"
          id="name"
          label="Nombre de Propietario"
          type="text"
          variant="outlined"
          fullWidth
          onChange={(e) => setNewOwnerName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <ButtonMaterial
          onClick={handleSaveReceiptData}
          color="secondary"
          variant="outlined"
          disabled={!newOwnerName}
        >
          Guardar
        </ButtonMaterial>
        <ButtonMaterial
          onClick={handleCloseReceiptDialog}
          sx={{ backgroundColor: '#D64539', color: 'white' }}
          variant="contained"
        >
          Cancelar
        </ButtonMaterial>
      </DialogActions>
    </Dialog>
  );

  const displayCharge = (charge) => {
    if (charge.visible == 1) {
      if (mimicoView) {
        return (
          <Grid2 size={{ lg: 4, md: 6, xs: 12 }} key={charge.id}>
            <MimicoCard
              charge={charge}
              groupId={groupId}
              typeEnergy={typeEnergy}
            />
          </Grid2>
        );
      } else {
        return (
          <Grid2 size={{ lg: 4, md: 6, xs: 12 }} key={charge.id}>
            <ChargeCard
              // deleteButton={showDeleteButton}
              //editButton={showEditButton}
              key={charge.id}
              charge={charge}
              groupId={groupId}
              item
              setSelectedCharge={setSelectedCharge}
              setShowDetails={setShowDetails}
              typeEnergy={typeEnergy}
              setOpenReceiptDialog={setOpenReceiptDialog}
              snapShopView={snapShopView}
              setSnapShopView={setSnapShopView}
              setSolarCapacity={setSolarCapacity}
              // key={group.id}
            />
            <div>
              {charge.type_unit === 'VOLTAJE'
                ? ''
                : getInvoiceDataButton(charge)}
              {charge.type_unit === 'VOLTAJE' ? '' : getReceiptData(charge)}
              {getEditButton(charge)}
              {getDeleteButton(charge)}
            </div>
          </Grid2>
        );
      }
    } else {
      return null;
    }
  };

  const apportionment = () => {
    const handleDelete = (index) => {
      const updatedApportionments = [...apportionments];
      updatedApportionments.splice(index, 1);
      setApportionments(updatedApportionments);
    };

    const handleAdd = () => {
      const { group, groupName, charge, chargeName } = newApportionment;
      if (!group || !charge) {
        Swal.fire({
          text: 'Por favor, completa ambos campos antes de agregar.',
          icon: 'warning',
          customClass: {
            popup: 'swalCustomIndex',
          },
        });
      }
      if (group || charge) {
        setApportionments([
          ...apportionments,
          { group, groupName, charge, chargeName },
        ]);
        setNewApportionment({
          group: '',
          groupName: '',
          charge: '',
          chargeName: '',
        });
        setListCharges([]);
      }
    };

    const handleChangeNew = (name) => async (event) => {
      const value = event.target.value;

      if (name === 'group') {
        const selectedGroup = groups.find((group) => group.id === value);
        setNewApportionment({
          ...newApportionment,
          group: value,
          groupName: selectedGroup ? selectedGroup.name : '',
        });
        await fetchCharges(value);
      } else if (name === 'charge') {
        const selectedCharge = listCharges.find(
          (charge) => charge.id === value
        );
        setNewApportionment({
          ...newApportionment,
          charge: value,
          chargeName: selectedCharge ? selectedCharge.name : '',
        });
      }
    };

    const fetchCharges = async (groupId) => {
      try {
        const response = await axios.get(
          `https://api.metimur.mx/api/group/${groupId}/charges`,
          getConfig()
        );
        setListCharges(response.data.data);
      } catch (error) {
        console.error('Error al cargar los cargos:', error);
      }
    };

    return (
      <Grid2 container={true} spacing={2} alignItems="center" justify="center">
        <Typography
          variant="body1"
          align="center"
          style={{ fontStyle: 'italic' }}
          width="100%"
        >
          Selecciona las Cargas que Deseas Prorratear
        </Typography>
        {apportionments?.map((apportionment, index) => (
          <Grid2
            size={12}
            container={true}
            key={index}
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <Grid2 size={5}>
              <TextField
                id={`group-label-${index}`}
                label="Grupo"
                disabled
                fullWidth
                value={apportionment.groupName}
                variant="outlined"
              />
            </Grid2>
            <Grid2 size={6}>
              <TextField
                id={`charge-label-${index}`}
                label="Carga"
                disabled
                fullWidth
                value={apportionment.chargeName}
                variant="outlined"
              />
            </Grid2>
            <Grid2 size={1}>
              <IconButton onClick={() => handleDelete(index)}>
                <Tooltip title="Eliminar">
                  <Delete />
                </Tooltip>
              </IconButton>
            </Grid2>
          </Grid2>
        ))}

        <Grid2
          size={12}
          container={true}
          spacing={2}
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid2 size={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="group-label-new">Grupo</InputLabel>
              <Select
                labelId="group-label-new"
                value={newApportionment.group}
                onChange={handleChangeNew('group')}
                label="Grupo"
              >
                {groups.map((group) => (
                  <MenuItem key={group.id} value={group.id}>
                    {group.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="charge-label-new">Carga</InputLabel>
              <Select
                labelId="charge-label-new"
                value={newApportionment.charge}
                onChange={handleChangeNew('charge')}
                label="Carga"
              >
                {listCharges.map((charge) => (
                  <MenuItem key={charge.id} value={charge.id}>
                    {charge.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <ButtonMaterial
            color="secondary"
            onClick={handleAdd}
            variant="outlined"
            fullWidth
          >
            Agregar
          </ButtonMaterial>
        </Grid2>
      </Grid2>
    );
  };

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '50px',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          {charges.length > 0 ? (
            <Grid2 container={true} spacing={2}>
              {charges
                .sort((a, b) => {
                  if (a.charge_status == b.charge_status) {
                    return a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0;
                  } else {
                    if (a.charge_status == 1) {
                      return -1;
                    } else {
                      return 1;
                    }
                  }
                })
                .map((charge) => displayCharge(charge))}
            </Grid2>
          ) : (
            <Grid2 container={true} spacing={4}>
              <Grid2 size={12}>
                <Typography sx={{ textAlign: 'center' }} variant="h2">
                  {intl.formatMessage({
                    id: 'app.chargesCards.noChargeMsg',
                  })}{' '}
                </Typography>
              </Grid2>
            </Grid2>
          )}
        </>
      )}
      {/* <Button
          icon="fas fa-file-invoice"
          onClick={()=> setShowReceiptDataButton(!showReceiptDataButton)}
          styles={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em'
          }}
          tooltip={intl.formatMessage({id: 'app.chargesCards.receiptData.title'})}
        />

        <Button
          icon="fas fa-file-invoice-dollar"
          onClick={() => setShowInvoiceDataButton(!showInvoiceDataButton)}
          styles={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em'
          }}
          tooltip={intl.formatMessage({id: 'app.chargesCards.invDataBtn.toolTip'})}
        />


        {isAllowed(user.permissions, ['charge_delete']) && (
          <Button
            icon="fa fa-trash"
            onClick={() => setShowDeleteButton(!showDeleteButton)}
            styles={{
              backgroundColor: '#00AFEF',
              color: '#fff',
              width: '60px',
              height: '60px',
              fontSize: '1.5em'
            }}
            tooltip={intl.formatMessage({id: 'app.chargesCards.deleteChargeBtn.toolTip'})}
          />
        )}
        {isAllowed(user.permissions, ['charge_update']) && (
          <Button
            icon="fa fa-pencil-alt"
            onClick={() => setShowEditButton(!showEditButton)}
            styles={{
              backgroundColor: '#00AFEF',
              color: '#fff',
              width: '60px',
              height: '60px',
              fontSize: '1.5em'
            }}
            tooltip={intl.formatMessage({id: 'app.chargesCards.editChargeBtn.toolTip'})}
          />
        )} */}

      {/* {isAllowed(user.permissions, ['charge_create']) && (
          <LinkFloat
            href={`/newCharge/${groupId}`}
            icon="fa fa-plus"
            styles={{
              backgroundColor: '#00AFEF',
              color: '#fff',
              width: '60px',
              height: '60px',
              fontSize: '1.5em',
            }}
            tooltip={intl.formatMessage({
              id: 'app.chargesCards.addChargeBtn.toolTip',
            })}
          />
        )} */}

      {/* <Button
          icon="fa fa-cog"
          rotate
          styles={{
            backgroundColor: '#C69100',
            color: '#fff',
            width: '80px',
            height: '80px',
            fontSize: '1.5em'
          }}
        /> */}
      <Dialog
        onClose={() => {
          setShowDetails(false);
          setActiveStep(0);
        }}
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth={'sm'}
        open={showDetails}
      >
        <DialogTitle
          onClose={() => {
            setShowDetails(false);
            setActiveStep(0);
          }}
          id="customized-dialog-title"
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography variant="h6">
                {selectedCharge ? selectedCharge.name : ''}
              </Typography>
              <Typography variant="body2">
                {chargeVolts[0] ? chargeVolts[0].name : ''}
                {owner && owner.owner !== null ? ` - ${owner?.owner}` : ''}
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => {
                setShowDetails(false);
                setActiveStep(0);
              }}
              size="small"
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ marginBottom: '3rem' }}>
          <AppBar
            position="static"
            color="transparent"
            sx={{ boxShadow: 'none', marginTop: '.5rem' }}
          >
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              TabIndicatorProps={{
                style: {
                  backgroundColor: tabIndex === 0 ? '#FEC12C' : '#A53693',
                },
              }}
              variant="fullWidth"
            >
              <Tab
                sx={{ fontSize: '1rem', color: '#FEC12C' }}
                label={intl.formatMessage({
                  id: 'app.chargesCards.addCharge.stepper.measurement.title',
                })}
              />
              <Tab
                sx={{ fontSize: '1rem', color: '#A53693 !important' }}
                label={intl.formatMessage({
                  id: 'app.chargesCards.addCharge.stepper.setting.title',
                })}
              />
            </Tabs>
          </AppBar>
          {selectedCharge && chargeInfo ? (
            <Box sx={{ marginTop: '3rem' }}>
              {tabIndex === 0 && comunicaciones()}
              {tabIndex === 1 && medicion()}
            </Box>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50vh',
              }}
            >
              <CircularProgress />
            </div>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        onClose={() => {
          setSnapShopView(false);
        }}
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth={'lg'}
        open={snapShopView}
        sx={{ zIndex: 1050 }}
      >
        <DialogTitle
          onClose={() => setSnapShopView(false)}
          id="customized-dialog-title"
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography gutterBottom variant="h5">
                Configuración de Snapshots{' '}
                {selectedCharge ? `- ${selectedCharge.name}` : ''}
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => setSnapShopView(false)}
              size="small"
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <FromStrepper
            formData={formData}
            setFormData={setFormData}
            selectedCharge={selectedCharge}
          />
          {/* {renderDias()} */}
        </DialogContent>
        <DialogActions>
          {snapShot && snapShot.length > 0 ? (
            <ButtonMaterial
              color="secondary"
              variant="contained"
              onClick={handleSnapShot}
              disabled={
                !formData.resource_id ||
                !formData.frecuency_config.periods.length ||
                !formData.frecuency_config.days.length ||
                !formData.contacts.length
              }
            >
              Editar
            </ButtonMaterial>
          ) : (
            <ButtonMaterial
              color="secondary"
              variant="contained"
              onClick={handleSnapShot}
              disabled={
                !formData.resource_id ||
                !formData.frecuency_config.periods.length ||
                !formData.frecuency_config.days.length ||
                !formData.contacts.length
              }
            >
              Guardar
            </ButtonMaterial>
          )}
          <ButtonMaterial
            color="secondary"
            variant="outlined"
            onClick={() => setSnapShopView(false)}
          >
            Cerrar
          </ButtonMaterial>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAppotioments}
        onClose={() => setOpenApportiments(false)}
        aria-labelledby="form-dialog-title"
        fullWidth
        style={{ zIndex: 1050 }}
        maxWidth="md"
      >
        <DialogTitle display="flex" justifyContent="space-between">
          <Chip
            label="Prorrateo de Cargas"
            sx={{
              background: '#A53693',
              color: 'white',
            }}
          />
          <IconButton
            aria-label="close"
            onClick={() => setOpenApportiments(false)}
            size="small"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>{apportionment()}</DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="contained"
            disabled={!apportionments.length}
            onClick={handleAppointment}
          >
            Guardar
          </Button>
          <Button
            color="info"
            variant="outlined"
            onClick={() => setOpenApportiments(false)}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      {receiptDialog}
      <Dialog
        open={solarCapacity}
        onClose={() => setSolarCapacity(false)}
        fullWidth
        maxWidth={'sm'}
        sx={{ zIndex: 1050 }}
      >
        <DialogTitle>
          <Typography variant="h5">Capacidad Instalada Mensual</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textDisabled">
            Configura la Capacidad Instalada Mensual
          </Typography>
          <TextField
            label="Capacidad Instalada Mensual"
            variant="outlined"
            onChange={(e) => setSolarInput(e.target.value)}
            value={solarInput}
            fullWidth={true}
            sx={{ mt: 2 }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">kWh</InputAdornment>
                ),
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <ButtonMaterial
            color="secondary"
            variant="outlined"
            disabled={!solarInput}
            onClick={() => handleSolarCapacity()}
          >
            Guardar
          </ButtonMaterial>
          <ButtonMaterial
            color="error"
            variant="contained"
            onClick={() => setSolarCapacity(false)}
          >
            Cerrar
          </ButtonMaterial>
        </DialogActions>
      </Dialog>
    </div>
  );
}
